import type {Expand} from '../types';

import {userExpandCommon} from '../user';

export const paymentExpandCommon: Expand = {
  payment: [
    'course_id',
    ['program_id', {title: 'Program not found'}, {program: ['avatar_id']}],
    ['user_id', {name: 'User not found'}, userExpandCommon],
    ['refund_ids', null, {refund: ['refund_payment_id->refundPayment']}],
  ],
};
